import React from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const getMonthName = (val) => {
  if (val === 1) return "Januar";
  if (val === 2) return "Februar";
  if (val === 3) return "März";
  if (val === 4) return "April";
  if (val === 5) return "Mai";
  if (val === 6) return "Juni";
  if (val === 7) return "Juli";
  if (val === 8) return "August";
  if (val === 9) return "September";
  if (val === 10) return "Oktober";
  if (val === 11) return "November";
  if (val === 12) return "Dezember";
};

export default function ClimateChart(props) {
  const { hotelRegion } = props;

  const [climateData, setClimateData] = React.useState([]);
  const [climateProperties, setClimateProperties] = React.useState([]);

  React.useEffect(() => {
    let data = Array(12).fill({});
    let cp = [];
    if (
      hotelRegion &&
      hotelRegion.RegionClimate &&
      Array.isArray(hotelRegion.RegionClimate.ClimateParameter)
    ) {
      for (
        let i = 0;
        i < hotelRegion.RegionClimate.ClimateParameter.length;
        i++
      ) {
        let cpv = {};
        if (
          Array.isArray(
            hotelRegion.RegionClimate.ClimateParameter[i].ClimateParameterValue
          )
        ) {
          for (
            let j = 0;
            j <
              hotelRegion.RegionClimate.ClimateParameter[i]
                .ClimateParameterValue.length && j < 12;
            j++
          ) {
            //console.log(hotelRegion.RegionClimate.ClimateParameter[i].ClimateParameterValue[j]);
            let dat = { ...data[j] };
            dat["Name" + i] =
              hotelRegion.RegionClimate.ClimateParameter[
                i
              ].ClimateParameterType;
            dat["Value" + i] =
              hotelRegion.RegionClimate.ClimateParameter[i]
                .ClimateParameterValue[j].value * 1;
            dat.Name = getMonthName(
              hotelRegion.RegionClimate.ClimateParameter[i]
                .ClimateParameterValue[j].Month
            );

            data[j] = { ...dat };
            cpv.dataKey = "Value" + i;
            cpv.name =
              hotelRegion.RegionClimate.ClimateParameter[
                i
              ].ClimateParameterType;
            cpv.color =
              hotelRegion.RegionClimate.ClimateParameter[
                i
              ].ClimateParameterType.indexOf("Water") > -1
                ? "#005477"
                : "#f9d71c";
          }
          cp.push({ ...cpv });
        }
      }
    }
    setClimateData(data);
    setClimateProperties(cp);
  }, [hotelRegion]);

  return (
    <>
      {hotelRegion.Name}
      <br />
      <LineChart
        width={1200}
        height={300}
        data={climateData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="Name" />
        <YAxis />
        <Tooltip />
        <Legend />
        {climateProperties.map((line, idx) => (
          <Line
            type="monotone"
            dataKey={line.dataKey}
            name={line.name}
            stroke={line.color}
          />
        ))}
      </LineChart>
    </>
  );
}
